<template>
  <v-app-bar
    id="core-app-bar"
    absolute
    app
    color="transparent"
    flat
    prominent
  >
    <v-toolbar
      prominent
      fixed
      flat
      color="transparent"
    >
      <v-toolbar-title class="tertiary--text font-weight-light align-self-center">
        <v-btn
          v-if="responsive"
          dark
          icon
          @click.stop="onClick"
        >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>

      <v-spacer/>
      <v-row justify="end">
        <v-toolbar-items>
          <v-row
            align="center"
            class="mx-0"
          >
            <div
              v-if="user && user.is_admin"
              id="unity-global-select"
            >
              <v-select
                v-model="current_unity"
                max-width="30px"
                fixed
                :items="unities.items"
                :loading="loading"
                item-text="name"
                item-value="id"
                return-object
                single-line
                denso
              />
            </div>
            <v-btn
              v-if="!responsive"
              to="/user-profile"
              icon
            >
              <v-icon color="tertiary">
                mdi-account
              </v-icon>
            </v-btn>

            <v-btn
              v-if="!responsive"
              icon
              @click="LOGOUT"
            >
              <v-icon color="tertiary">
                mdi-logout
              </v-icon>
            </v-btn>
          </v-row>
        </v-toolbar-items>
      </v-row>
    </v-toolbar>
  </v-app-bar>
</template>

<script>
    // Utilities
    import {
        mapMutations,
        mapState,
    } from 'vuex'

    export default {
        data: () => ({
            title: null,
            responsive: false,
        }),


        mounted() {
            this.onResponsiveInverted()
            window.addEventListener('resize', this.onResponsiveInverted)
            if (this.user.is_admin) this.$store.dispatch('unity/LIST')
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResponsiveInverted)
        },
        computed: {
            ...mapState('unity', ['unities']),
            ...mapState('app', ['loading']),
            ...mapState('account', ['user']),
            current_unity: {
                get() {
                    return this.$store.state.account.current_unity
                },
                set(current_unity) {
                    return this.CHANGE_CURRENT_UNITY(current_unity)
                },
            },

        },
        methods: {
            ...mapMutations('account', ['LOGOUT', 'CHANGE_CURRENT_UNITY']),
            ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
            onClick() {
                this.setDrawer(!this.$store.state.app.drawer)
            },
            onResponsiveInverted() {
                this.responsive = (window.innerWidth < 991)
            },
        },
        watch: {
            $route(val) {
                this.title = val.name
            },
        },
    }
</script>

<style>
  /* Fix coming in v2.0.8 */
  #core-app-bar {
    width: auto;
  }

  #core-app-bar a {
    text-decoration: none;
  }

  #unity-global-select {
    max-width: 250px;
  }
</style>
